import {
  Box,
  Typography,
  Paragraph,
  Icon,
  Link,
  Button,
} from "@bca/ui-library";
import Layout from "../Layout";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

interface ErrorPageProps {
  user?: any;
  idToken?: string;
  isToUseAuthZero?: boolean;
  isAuthenticated?: boolean;
  logoutUrl?: string;
}

const ErrorPage = ({
  user,
  idToken,
  isToUseAuthZero = false,
  isAuthenticated,
  logoutUrl,
}: ErrorPageProps) => {
  const {
    isAuthenticated: isAuthenticatedFromLib,
    authUser,
    idToken: idTokenFromLib,
  } = useAuth(!isToUseAuthZero);
  let message = "An unexpected error occured.";

  return (
    <Layout
      user={user ?? authUser}
      idToken={idToken ?? idTokenFromLib}
      isToUseAuthZero={isToUseAuthZero}
      isAuthenticated={isAuthenticated ?? isAuthenticatedFromLib}
      logoutUrl={logoutUrl}
    >
      <Box pt="15vh" pb="12.5vh" px="20px">
        <Box display="flex" justifyContent="center">
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            width={{ mobile: "90%", tablet: "490px", desktop: "560px" }}
          >
            <Icon
              name={"exclamation-triangle"}
              color="grey-blue"
              width="72px"
            />
            <Typography
              variant="h4"
              mb={0}
              textAlign={"center"}
              color="footer-blue"
            >
              {"Sorry, something went wrong..."}
            </Typography>
            <Paragraph
              textAlign={"center"}
              fontSize="18px"
              lineHeight="1.4"
              color="grey-blue"
            >
              {`${message} Please try again or check back later. If this error persists please `}
              <Link color="primary-light-blue" href={""}>
                contact support.
              </Link>
            </Paragraph>
            <Box py="10px">
              <Button
                variant="secondary"
                width="160px"
                onClick={() => window.location.reload()}
              >
                Refresh Page
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default ErrorPage;
